/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-07-12",
    versionChannel: "nightly",
    buildDate: "2024-07-12T00:05:18.191Z",
    commitHash: "393ffe05ef0894768f7d938c1dee0314cdcaa794",
};
